import { cloneElement } from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import ProjectGroupModule from '../../../redux/project_grouping';
import { isDependencyCacheValid } from '../../../helpers/revisions';


const ProjectGroupDependencyValidityContainer = ({release, isReleaseLoading, ...props}) => {
  if (!release || isReleaseLoading) {
    return null;
  }

  const allDependencyCacheValid = release.projects.every(
    project =>
      isDependencyCacheValid(project.revision)
  );

  return <>
    {allDependencyCacheValid ?
      cloneElement(props.children, props)
      :
      <div className="container container-responsive">
        <div className="margin-top">
          <div className="alert alert-warning">Please wait while FOSSA determines the dependencies for this revision, this step can take a few minutes to complete...</div>
        </div>
      </div>
    }
  </>;
};

const mapStateToProps = createStructuredSelector({
  release: ProjectGroupModule.selectors.getRelease,
  isReleaseLoading: ProjectGroupModule.selectors.getReleaseIsLoading,
});

export default connect(
  mapStateToProps,
)(ProjectGroupDependencyValidityContainer);
